import * as React from "react";
import { Language } from "typings/index";
import { 
    CommandBar, 
    ICommandBarItemProps,
    TextField, 
} from "office-ui-fabric-react";
import { Map } from "~/../typings";
import { GetLanguageMenu } from "./languageHelper";
export interface Props
{
    onValueChange: (language: string, value: string) => void; 
    values?: Map<string>;
    languages: Language[];
    languageDefaultIndex: number;
    focus?: boolean;
}

function TextEditor(props: Props)
{
    const [language, setLanguage] = React.useState<Language>(props.languages[props.languageDefaultIndex]);
    const onTextChange = (event: React.ChangeEvent<HTMLTextAreaElement>, newValue: string | undefined) =>
    {
        props.onValueChange(language.name, newValue ? newValue : "");

    };
       
    const commandBarOptions: ICommandBarItemProps[] = GetLanguageMenu(props.languages, setLanguage, language);

  
    return (
        <div className="locale-textarea">
            <CommandBar
                style={{background: "transparent"}}
                items={commandBarOptions}
            />
            <TextField 
                autoFocus={props.focus}
                onChange={onTextChange}
                value={props.values && props.values[language.name] ? props.values[language.name] : ""} 
                multiline 
                autoAdjustHeight 
            />
        </div>
    );
}

export default TextEditor;


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/localeTextareaEditor/TextEditor.tsx